import { postToServer } from "@/client/utils/postToServer";
import {
    kLibrarySearchEndpoint,
    type LibrarySearchRequestBody,
    type LibrarySearchSuccessResponse,
} from "@/shared/library-search.api";
import { createErrorMessage } from "@/shared/utils/error";

export interface LibrarySearchService {
    search: (body: LibrarySearchRequestBody) => Promise<LibrarySearchSuccessResponse | Error>;
}

/** The signed-in user's licensed samples. See `shared/library-search.api.ts`. */
export const createLibrarySearchService = (): LibrarySearchService => ({
    search: async (body) => {
        try {
            return await postToServer(kLibrarySearchEndpoint, body);
        } catch (error) {
            return new Error(createErrorMessage(error));
        }
    },
});
